document.addEventListener("DOMContentLoaded", () => {
  if (customElements.get("full-screen-modal")) return;

  class FullScreenModal extends HTMLElement {
    constructor() {
      super();
      this.contentEl = null;
      this.triggerEl = null;
      this.closeEl = null;

      this.handleOpen = this.handleOpen.bind(this);
      this.handleClose = this.handleClose.bind(this);
      this.handleMaskClick = this.handleMaskClick.bind(this);
      this.stopPropagation = this.stopPropagation.bind(this);
    }

    connectedCallback() {
      this.initElements();
      this.moveContentToBody();
      this.bindEvents();
    }

    disconnectedCallback() {
      this.unbindEvents();
    }

    initElements() {
      this.contentEl = this.querySelector(".content");
      this.triggerEl = this.querySelector(".trigger");

      if (!this.contentEl) return;

      this.closeEls = this.contentEl.querySelectorAll(".close");
      this.maskEl = this.contentEl.querySelector(".mask");
    }

    moveContentToBody() {
      if (!this.contentEl) return;

      if (this.contentEl.__moved) return;

      this.contentEl.__moved = true;
      this.contentEl.classList.add("image-preview-root");
      this.contentEl.style.display = "none";

      document.body.appendChild(this.contentEl);
    }

    bindEvents() {
      this.triggerEl?.addEventListener("click", this.handleOpen);

      this.closeEls.forEach((el) => {
        el.addEventListener("click", this.handleClose);
      });

      if (this.maskEl) {
        this.maskEl.addEventListener("click", this.handleMaskClick);

        // 阻止 mask 内部点击冒泡
        this.maskEl.querySelectorAll("*").forEach((el) => {
          el.addEventListener("click", this.stopPropagation);
        });
      }
    }

    unbindEvents() {
      this.triggerEl?.removeEventListener("click", this.handleOpen);

      this.closeEls.forEach((el) => {
        el.removeEventListener("click", this.handleClose);
      });

      if (this.maskEl) {
        this.maskEl.removeEventListener("click", this.handleMaskClick);

        this.maskEl.querySelectorAll("*").forEach((el) => {
          el.removeEventListener("click", this.stopPropagation);
        });
      }
    }

    handleOpen() {
      if (!this.contentEl) return;

      this.contentEl.style.display = "block";
      requestAnimationFrame(() => {
        this.contentEl.classList.add("is-open");
      });

      document.body.style.overflow = "hidden";

      window.dispatchEvent(
        new CustomEvent("full-screen-modal-open", {
          detail: {
            contentEl: this.contentEl,
          },
        })
      );
    }

    handleClose() {
      if (!this.contentEl) return;

      this.contentEl.classList.remove("is-open");

      this.contentEl.style.display = "none";

      document.body.style.overflow = "";

      window.dispatchEvent(
        new CustomEvent("full-screen-modal-close", {
          detail: {
            contentEl: this.contentEl,
          },
        })
      );
    }

    handleMaskClick(e) {
      // 只在点击 mask 自身时关闭
      if (e.target === this.maskEl) {
        this.handleClose();
      }
    }

    stopPropagation(e) {
      e.stopPropagation();
    }
  }

  customElements.define("full-screen-modal", FullScreenModal);
});
